if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const thumbsEl = this.querySelector('.product__media-thumbs-swiper');
        let thumbsSwiper = null;
        if (thumbsEl) {
          thumbsSwiper = new Swiper(thumbsEl, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            watchSlidesProgress: true,
            freeMode: true,
          });
        }

        let options = {
          slidesPerView: 1,
          direction: 'horizontal',
          freeMode: false,
          longSwipes: false,
          scrollbar: {
            el: this.querySelector('.swiper-scrollbar'),
            hide: false,
            draggable: true,
            verticalClass: 'disabled-vertical',
          },
        };

        if (thumbsSwiper) {
          options.thumbs = { swiper: thumbsSwiper };
        }

        this.swiper = new Swiper(this.querySelector('.swiper'), options);
      }

      swiperUpdateSlides() {
        this.swiper.updateSlides();
      }

      swiperUpdate() {
        this.swiper.update();
      }

      swiperSlideTo(index) {
        this.swiper.slideTo(index);
      }

      getDirection() {
        return 'horizontal';
      }
    }
  );
}
